/* eslint-disable max-len */

import {
  useDev,
  formItemTypeEnum,
  useNormalizer,
  useDeleteNulls,
} from '@sttedra_ui/framework';

import {useValidations} from '@sttedra_ui/framework';
import useValidationsRegister from '@/composables/validations-register';

// import {ErrorsMessages} from '@/enum/messages.enum.js';
import {useDatesEnum} from '@/composables/use-dates-enum/use-dates-enum.js';

// import {useEventListener} from '@vueuse/core';

// #region API
import listOfMunipalCodesIne from '@/pages/_root/views/register/listOfMunipalCodesIne.json';
// #endregion

import {
  onMountedFieldDate,
  onDateSelect,
  onShow,
  onHide,
} from './form.view-controller.js';

const {getString} = useNormalizer();
const {
  required,
  // sameAs,
} = useValidations();

const {
  nifNieValidation,
  validatorName,
  validatorSurname,
  validatorSecondName,
  // requireNumValidation,
  supportNumValidationNIE,
} = useValidationsRegister();

const Dates = useDatesEnum();
const initDate = new Date(Dates.INIT_CODIGO_MINOR);

const today = new Date();
today.setHours(0, 0, 0, 0);
const limitDateRaw = new Date(Dates.END_CODIGO_MINOR);
limitDateRaw.setHours(0, 0, 0, 0);
const limitDate = limitDateRaw > today ? today : limitDateRaw;

const initExpirationDniDate = new Date(Dates.INIT);
initExpirationDniDate.setFullYear(initExpirationDniDate.getFullYear() + 14);

function isNie(value) {
  if (!getString(value)) return false;

  const firstChat = value.charAt(0).toUpperCase();
  if (firstChat === 'X' || firstChat === 'Y' || firstChat === 'Z') {
    return true;
  }

  return false;
}

function manageSupportNie(value, eventHelpers) {
  const isShowNieSup = isNie(value);
  const dClass = ['form-item--depend-field'];
  const classObj = isShowNieSup ?
    [...dClass, 'form-item--depend-field-show'] :
    dClass;

  if (isShowNieSup) {
    const fieldDate = document.querySelector('.form__item--validdatedni input');
    if (fieldDate) {
      fieldDate.value = '';
    }
    eventHelpers.changeFieldValue('validDateDNI', null);
  }

  eventHelpers.changeFieldClassObj('supportNumber', classObj);
  eventHelpers.changeFieldProperties('supportNumber', {
    placeholder: '',
    inputProps: {
      tabIndex: isShowNieSup ? 0 : -1,
    },
    // max: 99999999,
    useGrouping: false,
  });

  const field = document.querySelector('.form__item--supportnumber input');
  const icon = document.querySelector('.form__item__supportnumber--icon');
  if (field) {
    field.tabIndex = isShowNieSup ? 0 : -1;
  }
  if (icon) {
    icon.tabIndex = isShowNieSup ? 0 : -1;
  }
}

function manageDniValidateDate(value, eventHelpers) {
  const isShowDniDate = !isNie(value);
  const dClass = ['form-item--depend-field'];
  const classObj = isShowDniDate ?
    [...dClass, 'form-item--depend-field-show'] :
    dClass;

  if (isShowDniDate) {
    const fieldDate = document.querySelector(
      '.form__item--supportnumber input',
    );
    if (fieldDate) {
      fieldDate.value = '';
    }
    eventHelpers.changeFieldValue('supportNumber', null);
  }

  eventHelpers.changeFieldClassObj('validDateDNI', classObj);
  eventHelpers.changeFieldProperties('validDateDNI', {
    placeholder: '',
    manualInput: true,
    showOnFocus: false,
    showIcon: true,
    inputProps: {
      tabIndex: isShowDniDate ? 0 : -1,
    },
    minDate: initExpirationDniDate,
    showOnFocus: isShowDniDate,
  });

  const field = document.querySelector('.form__item--validdatedni input');
  const button = document.querySelector(
    '.form__item--validdatedni .p-datepicker-trigger',
  );
  const icon = document.querySelector('.form__item__validdatedni--icon');
  if (field) {
    field.tabIndex = isShowDniDate ? 0 : -1;
  }
  if (button) {
    button.tabIndex = isShowDniDate ? 0 : -1;
  }
  if (icon) {
    icon.tabIndex = isShowDniDate ? 0 : -1;
  }
}

export default function({
  data,
  buildPolityModal,
  checkCorrectBirthDate,
  showDisclaimerSecondSurname,
  hideDisclaimerSecondSurname,
  onChangeRulesForm,
}) {
  const isLogged = false;
  const requiredString = isLogged ? '' : '(*)';

  return {
    items: [
      {
        field: 'identificationNumber',
        label: `DNI/NIE ${requiredString}`,
        clear: false,
        errorMessage: 'Campo DNI/NIE en blanco o formato no válido',
        floatDisabled: true,
        rules: {
          required,
          nifNieValidation,
        },
        type: formItemTypeEnum.INPUTTEXT,
        value: data?.identificationNumber || null,
        classObj: isLogged ? ['form-item--read-only'] : [''],
        properties: {
          placeholder: '',
          readonly: isLogged ? true : false,
        },
        events: {
          onMounted: async (updater, eventHelpers) => {
            try {
              const field = document.querySelector(
                '.form__item--identificationnumber input',
              );
              if (field) {
                field.tabIndex = isLogged ? -1 : 0;
                field.setAttribute('aria-label', 'Identificación DNI o NIE');
                field.setAttribute('required', true);
              }

              if (data?.identificationNumber) {
                if (showDisclaimerSecondSurname) {
                  showDisclaimerSecondSurname();
                }

                manageSupportNie(
                  data?.identificationNumber,
                  eventHelpers,
                  onChangeRulesForm,
                );

                if (!isLogged) {
                  manageDniValidateDate(
                    data?.identificationNumber,
                    eventHelpers,
                  );
                }
              }

              if (!data?.identificationNumber && hideDisclaimerSecondSurname) {
                hideDisclaimerSecondSurname();
              }
            } catch (error) {
              useDev.error('[form.view-config.js] onMounted', error);
            }
          },
          input: ($event, updater, eventHelpers) => {
            try {
              const value = $event.target?.value || null;
              if (value) {
                if (showDisclaimerSecondSurname) {
                  showDisclaimerSecondSurname();
                }

                manageSupportNie(value, eventHelpers, onChangeRulesForm);

                if (!isLogged) {
                  manageDniValidateDate(value, eventHelpers);
                }

                return;
              }

              if (!value && hideDisclaimerSecondSurname) {
                hideDisclaimerSecondSurname();
              }

              const field = document.querySelector(
                '.form__item--validdatedni input',
              );
              const btn = document.querySelector(
                '.form__item--validdatedni .p-datepicker-trigger',
              );

              if (field) field.tabIndex = -1;
              if (btn) btn.tabIndex = -1;

              const fieldSupportNumber = document.querySelector(
                '.form__item--supportnumber input',
              );
              if (fieldSupportNumber) {
                fieldSupportNumber.tabIndex = -1;
              }

              eventHelpers.changeFieldClassObj('validDateDNI', [
                'form-item--depend-field',
              ]);
              eventHelpers.changeFieldClassObj('supportNumber', [
                'form-item--depend-field',
              ]);

              eventHelpers.changeFieldValue('supportNumber', null);
              eventHelpers.changeFieldValue('validDateDNI', null);

              eventHelpers.getV$().supportNumber.$reset();
              eventHelpers.getV$().validDateDNI.$reset();
            } catch (error) {
              useDev.error('[form.view-config.js] onMounted', error);
            }
          },
        },
      },
      {
        field: 'validDateDNI',
        type: formItemTypeEnum.CALENDAR,
        label: 'Fecha de validez del DNI ' + requiredString,
        value: data?.validDateDNI || null,
        classObj: data?.isDni && !isLogged ? [] : ['form-item--depend-field'],
        clear: false,
        floatDisabled: true,
        properties: {
          placeholder: '',
          manualInput: true,
          showOnFocus: false,
          showIcon: true,
          inputProps: {
            tabIndex: -1,
          },
        },
        rules: {
          required,
        },
        errorMessage:
          'Campo fecha de validez en blanco. Introduzca su fecha de validez',
        events: {
          onMounted: async ($updater, eventHelpers) => {
            const checkTabIndex =
              !isLogged &&
              data?.identificationNumber &&
              !isNie(data?.identificationNumber);
            eventHelpers.changeFieldValue(
              'validDateDNI',
              data?.validDateDNI || null,
            );
            onMountedFieldDate('validDateDNI', data, eventHelpers, {
              tabIndex: checkTabIndex ? 0 : -1,
            });
          },
          dateSelect: (value, updater, eventHelpers) => {
            onDateSelect(value, 'validDateDNI', eventHelpers);
          },
          show: ($event, updater, eventHelpers) => {
            onShow('validDateDNI', eventHelpers);
          },
        },
      },
      {
        field: 'supportNumber',
        type: formItemTypeEnum.INPUTTEXT,
        label: 'Número de soporte ' + requiredString,
        classObj: data?.isDni && !isLogged ? [] : ['form-item--depend-field'],
        clear: false,
        value: data?.supportNumber || null,
        floatDisabled: true,
        properties: {
          placeholder: '',
          useGrouping: false,
          inputProps: {
            tabIndex: -1,
          },
        },
        rules: {
          supportNumValidationNIE,
        },
        events: {
          input: ($event, updater, eventHelpers) => {
            const value = $event.target?.value || null;
            if (value) {
              const cleanedValue = value.toString().replace(/[\s.,]/g, '');
              eventHelpers.changeFieldValue('supportNumber', cleanedValue);
            }
          },
        },
      },
      {
        field: 'name',
        type: formItemTypeEnum.INPUTTEXT,
        label: 'Nombre ' + requiredString,
        clear: false,
        rules: {required, validatorName},
        errorMessage:
          'Campo nombre en blanco o con caracteres invalidos. Introduzca su nombre',
        value: data?.name || null,
        floatDisabled: true,
        properties: {
          placeholder: '',
        },
        events: {
          onMounted: async () => {
            const field = document.querySelector('.form__item--name input');
            if (field) {
              field.tabIndex = isLogged ? -1 : 0;
              field.setAttribute('aria-label', 'Nombre');
              field.setAttribute('required', true);
            }
          },
        },
      },
      {
        field: 'surname',
        type: formItemTypeEnum.INPUTTEXT,
        label: 'Apellido 1 ' + requiredString,
        clear: false,
        rules: {required, validatorSurname},
        value: data?.surname || null,
        errorMessage:
          'Campo apellido 1 en blanco o con caracteres invalidos. Introduzca su apellido 1',
        floatDisabled: true,
        properties: {
          placeholder: '',
        },
        events: {
          onMounted: async () => {
            const field = document.querySelector('.form__item--surname input');
            if (field) {
              field.tabIndex = isLogged ? -1 : 0;
              field.setAttribute('aria-label', 'Apellido 1');
              field.setAttribute('required', true);
            }
          },
        },
      },
      {
        field: 'secondSurname',
        type: formItemTypeEnum.INPUTTEXT,
        label: 'Apellido 2',
        value: data?.secondSurname || null,
        rules: {validatorSecondName},
        clear: false,
        floatDisabled: true,
        properties: {
          placeholder: '',
        },
        events: {
          onMounted: async () => {
            const field = document.querySelector(
              '.form__item--secondsurname input',
            );
            if (field) {
              field.tabIndex = isLogged ? -1 : 0;
              field.setAttribute('aria-label', 'Apellido 2');
              field.setAttribute('required', true);
              const floalLabel = document.querySelector(
                '.form__item--secondsurname .form-item__label',
              );
              if (floalLabel) {
                const spanInfo = document.createElement('span');
                spanInfo.classList.add('form-item__label__info');
                spanInfo.textContent = '(* Solo si consta en su documento)';
                floalLabel.appendChild(spanInfo);
              }
            }
          },
        },
      },
      {
        field: 'birthDate',
        type: formItemTypeEnum.CALENDAR,
        label: 'Fecha de nacimiento ' + requiredString,
        clear: false,
        classObj: isLogged ? ['form-item--hidden'] : [''],
        rules: {required},
        value: data?.birthDate || null,
        errorMessage: `Campo fecha de nacimiento en blanco.
        Introduzca su fecha de nacimiento. Formato DD/MM/YYYY`,
        floatDisabled: true,
        properties: {
          placeholder: '',
          manualInput: true,
          showOnFocus: false,
          showIcon: true,
          minDate: initDate,
          maxDate: limitDate,
        },
        events: {
          onMounted: async ($updater, eventHelpers) => {
            onMountedFieldDate(
              'birthDate',
              data,
              eventHelpers,
              {},
              checkCorrectBirthDate,
            );
          },
          dateSelect: (value, updater, eventHelpers) => {
            onDateSelect(
              value,
              'birthDate',
              eventHelpers,
              checkCorrectBirthDate,
            );
          },
          show: ($event, updater, eventHelpers) => {
            onShow('birthDate', eventHelpers);
          },
          hide: ($event, updater, eventHelpers) => {
            const rawValue = document.querySelector(
              '.form__item--birthdate input',
            )?.value;
            const [day, month, year] = rawValue?.split('/') || [];
            const parsedDate = new Date(`${year}-${month}-${day}`);

            if (!isNaN(parsedDate.getTime())) {
              parsedDate.setHours(0, 0, 0, 0);
              checkCorrectBirthDate(parsedDate);
            }

            onHide('birthDate', eventHelpers);
          },
        },
      },
      {
        field: 'codIneMunicipio',
        type: formItemTypeEnum.AUTOCOMPLETE,
        label: 'Municipio de residencia ' + requiredString,
        clear: false,
        floatDisabled: true,
        rules: {required},
        value: data?.codIneMunicipio || null,
        errorMessage:
          'Campo municipio en blanco. Seleccione su municipio de residencia',
        properties: {
          optionLabel: 'municipality',
          placeholder: 'Mínimo 3 caracteres',
          minLength: 3,
          forceSelection: true,
          appendTo: 'self',
          forceSelection: true,
          suggestions: [],
        },
        events: {
          complete: async ($event, updateModel /* Immer update function */) => {
            const {query} = $event;
            let suggestions = [];

            const normalizeText = (text) => {
              return text
                ?.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                ?.toLowerCase();
            };

            if (query && query.length >= 3) {
              const queryNormalized = normalizeText(query);

              suggestions = listOfMunipalCodesIne.filter((item) => {
                const municipalityNormalized = normalizeText(item.municipality);
                const postalCode = item.postalCode;
                return (
                  municipalityNormalized.includes(queryNormalized) ||
                  postalCode.includes(query)
                );
              });

              useDeleteNulls(suggestions);

              const municipalityCount = {};
              const municipalityIneCount = {};

              suggestions.forEach((item) => {
                const key = item.municipality;
                const keyWithIne = item.municipality + item.codIneMunicipio;

                if (!municipalityCount[key]) {
                  municipalityCount[key] = 0;
                }
                municipalityCount[key]++;

                if (!municipalityIneCount[keyWithIne]) {
                  municipalityIneCount[keyWithIne] = 0;
                }
                municipalityIneCount[keyWithIne]++;
              });

              const processedData = suggestions.reduce((acc, item) => {
                const keyWithIne = item.municipality + item.codIneMunicipio;

                if (
                  municipalityCount[item.municipality] > 1 &&
                  municipalityIneCount[keyWithIne] === 1
                ) {
                  acc.push({
                    ...item,
                    municipality: `${item.municipality} (${item.provinceName})`,
                  });
                } else if (
                  municipalityCount[item.municipality] === 1 ||
                  municipalityIneCount[keyWithIne] > 1
                ) {
                  if (
                    !acc.find(
                      (i) =>
                        i.municipality === item.municipality &&
                        i.codIneMunicipio === item.codIneMunicipio,
                    )
                  ) {
                    acc.push({...item});
                  }
                }
                return acc;
              }, []);

              const sortedData = processedData
                .filter((item) => item)
                .sort((a, b) => a.municipality.localeCompare(b.municipality));

              const exactMatchIndex = sortedData.findIndex(
                (item) =>
                  item.municipality.toLocaleLowerCase() ===
                  query.toLocaleLowerCase(),
              );
              if (exactMatchIndex !== -1) {
                const [exactMatch] = sortedData.splice(exactMatchIndex, 1);
                sortedData.unshift(exactMatch);
              }

              updateModel((model) => {
                model.properties.suggestions = sortedData;
              });
            } else {
              updateModel((model) => {
                model.properties.suggestions = suggestions;
              });
            }
          },
        },
      },
    ],
  };
}
